import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { useIsomorphicLayoutEffect } from './utils';
/**
 * This hook returns context selected value by selector.
 * It will only accept context created by `createContext`.
 * It will trigger re-render if only the selected value is referencially changed.
 */

var useContextSelector = function useContextSelector(context, selector) {
  var _React$useContext = React.useContext(context),
      subscribe = _React$useContext.subscribe,
      value = _React$useContext.value;

  var _ref = React.useReducer(function (c) {
    return c + 1;
  }, 0),
      _ref2 = _slicedToArray(_ref, 2),
      forceUpdate = _ref2[1];

  var ref = React.useRef();
  var selected = selector(value);
  useIsomorphicLayoutEffect(function () {
    ref.current = {
      selector: selector,
      value: value,
      selected: selected
    };
  });
  useIsomorphicLayoutEffect(function () {
    var callback = function callback(nextState) {
      try {
        var reference = ref.current;

        if (reference.value === nextState || Object.is(reference.selected, reference.selector(nextState))) {
          // not changed
          return;
        }
      } catch (e) {// ignored (stale props or some other reason)
      }

      forceUpdate();
    };

    return subscribe(callback);
  }, [subscribe]);
  return selected;
};

export default useContextSelector;